import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StaticMap from './StaticMap'
import classnames from 'classnames'

const options = {
  'Default' : 'mapbox/streets-v12',
  'High End': 'showcaseidx/cmbhz0g8500au01sccl73aws2',
  'Light and Bright': 'showcaseidx/cmbhzk8un00be01sd259i2chv',
  'Outdoors': 'mapbox/outdoors-v12',
  'Light Grey': 'mapbox/light-v11',
  'Northstar': 'showcaseidx/cmbi2zgb5005u01s63q90h03z',
  'Elegant': 'showcaseidx/cmbjdk1zn00go01se20fne4pe',
  'Classic': 'showcaseidx/cmbjd2m1v00mu01sd42n58sc2',
  'Muted Greyscale': 'showcaseidx/cmbjdatfs00mg01r0b6mg62iy'
}

export default class MapSelector extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    defaultSelected: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    defaultSelected: options[Object.keys(options)[0]]
  }

  state = {
    selected: this.props.defaultSelected
  }

  getOption = name => {
    const style = options[name]
    const { disabled } = this.props
    const { selected } = this.state
    const className = classnames('map-option', {
      selected: selected === style
    })
    return (
      <div
        key={style}
        className={className}
        onClick={() => !disabled && this.setState({ selected: style })}>
        <StaticMap style={style} />
        <label>{name}</label>
      </div>
    )
  }

  render() {
    const { disabled } = this.props

    return (
      <div className={classnames('map-selector', { disabled })}>
        {Object.keys(options).map(this.getOption)}
        <input type="hidden" name={this.props.name} value={this.state.selected}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/MapSelector/index.js